/** 對 val 四捨五入取小數點後第 precision 位 */
export function roundDecimal(val, precision) {
  return Math.round(Math.round(val * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0));
}

/** 對 val 無條件捨去取小數點後第 precision 位 */
export function floorDecimal(val, precision) {
  return Math.floor(Math.floor(val * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0));
}

/**
 * 計算元素邊框上下和左右的寬度
 */
export function getElementBorder(el: HTMLElement) {
  return {
    verticleWidth: el.offsetHeight - el.clientHeight, // 上下邊框總共佔據的寬度
    horizontalWidth: el.offsetWidth - el.clientWidth, // 左右邊框總共佔據的寬度
  };
}

/**
 * 計算元素內距
 */
export function getElementPadding(el: HTMLElement) {
  if (window.getComputedStyle) {
    const computedStyle = getComputedStyle(el, null);
    return {
      top: roundDecimal(parseFloat(computedStyle.paddingTop), 5),
      right: roundDecimal(parseFloat(computedStyle.paddingRight), 5),
      bottom: roundDecimal(parseFloat(computedStyle.paddingBottom), 5),
      left: roundDecimal(parseFloat(computedStyle.paddingLeft), 5),
    };
  } else {
    return {
      top: roundDecimal(parseFloat(getPixelValue(el, (el as any).currentStyle.paddingTop)), 5),
      right: roundDecimal(parseFloat(getPixelValue(el, (el as any).currentStyle.paddingRight)), 5),
      bottom: roundDecimal(parseFloat(getPixelValue(el, (el as any).currentStyle.paddingBottom)), 5),
      left: roundDecimal(parseFloat(getPixelValue(el, (el as any).currentStyle.paddingTop)), 5),
    };
  }
}

/**
 * 取得元素 px 單位寬度，(解決原本是相對單位尺寸)
 * copy from [here](https://stackoverflow.com/questions/28606058/what-is-the-equivalent-of-height-and-width-of-jquery-in-pure-javascript)
 */
export function getPixelValue(element, value) {
  if (/^\d+(px)?$/i.test(value)) { return parseInt(value, 10); }
  const style = element.style.left;
  const runtimeStyle = element.runtimeStyle.left;
  element.runtimeStyle.left = element.currentStyle.left;
  element.style.left = value || 0;
  value = element.style.pixelLeft;
  element.style.left = style;
  element.runtimeStyle.left = runtimeStyle;
  return value;
}

/**
 * 取得元素的位置(by px)
 * @param el HTML元素
 */
export function getElementStylePosition(el: HTMLElement) {
  if (window.getComputedStyle) {
    const computedStyle = getComputedStyle(el, null);
    const l = computedStyle.left;
    const t = computedStyle.top;
    return {
      left: l === 'auto' ? 0 : roundDecimal(parseFloat(l), 5),
      top: t === 'auto' ? 0 : roundDecimal(parseFloat(t), 5),
    };
  } else {
    el.style.left = (el as any).currentStyle.left || '0';
    el.style.top = (el as any).currentStyle.top || '0';
    return {
      left: roundDecimal((el.style as any).pixelLeft, 5),
      top: roundDecimal((el.style as any).pixelTop, 5),
    };
  }
}

/**
 * 取得元素的大小(by px)
 * @param el HTML元素
 */
export function getElementStyleSize(el: HTMLElement) {
  if (window.getComputedStyle) {
    const computedStyle = getComputedStyle(el, null);
    const w = computedStyle.width;
    const h = computedStyle.height;
    return {
      w: w === 'auto' ? 0 : roundDecimal(parseFloat(w), 5),
      h: h === 'auto' ? 0 : roundDecimal(parseFloat(h), 5),
    };
  } else {
    return {
      w: roundDecimal(parseFloat(getPixelValue(el, (el as any).currentStyle.width)), 5),
      h: roundDecimal(parseFloat(getPixelValue(el, (el as any).currentStyle.height)), 5),
    };
  }
}
